<template>
  <div>
    <v-container>
      <v-row>
        <v-col sm="12" lg="10" offset-lg="1" xl="8" offset-xl="2" class="pb-0">
          <h2 class="greend--text">Unser Betrieb</h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col sm="12" lg="10" xl="8" offset-lg="1" offset-xl="2">
          <v-row>
            <v-col
              cols="4"
              v-for="image in images.slice(0, 3)"
              :key="image.index"
              @click="showViewer(image.index)"
            >
              <v-img contain :src="image.src" class="elevation-5 viewerImg" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mx-2 mb-12">
              <v-card flat max-width="650" class="mx-auto text-center">
                <p>
                  Der Familienbetrieb wurde im Jahr 1996 von Irmgard und
                  Heinrich Heberlein gegründet.<br />
                  Derzeit beträgt die Größe des Betriebs 6 ha.
                </p>
                <p>
                  Neben Apfelminze und Orangenminze wachsen auf unseren Feldern
                  weitere Besonderheiten wie z.B. Drachenkopf und Anisysop. Zur
                  natürlichen Bodenregeneration gibt es einen regelmäßigen
                  Wechsel von Kräutern mit Leguminosen und anderen Pflanzen, 
                  die für eine gesunde Fruchtfolge sorgen.
                </p>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="4"
              v-for="image in images.slice(3, 6)"
              :key="image.index"
              @click="showViewer(image.index)"
            >
              <v-img contain :src="image.src" class="elevation-5 viewerImg" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mx-2">
              <v-card flat max-width="650" class="mx-auto text-center">
                <p>
                  Bei der Ernte legen wir viel Wert auf den schonenden Umgang
                  mit den Kräutern. Das Erntegut wird am Betrieb sofort
                  geschnitten, von groben Stängeln getrennt und getrocknet.
                </p>
                <p>
                  Unsere Luftentfeuchtungsanlage arbeitet bei niedriger
                  Temperatur und durch regelmäßiges Lockern wird der Ware
                  gleichmäßig die Feuchtigkeit entzogen. Durch dieses Verfahren
                  bleiben die natürlichen Aromen und Farben der Kräuter
                  erhalten.
                </p>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-card
                outlined
                class="text-center pa-8 ma-4 mx-auto"
                max-width="650"
              >
                <p>
                  Wenn Sie weitere Fragen haben, schicken Sie uns gerne eine
                  <br />E-Mail an
                  <a :href="`mailto:${email.addr}`">{{ email.text }}</a>
                </p>
                <p>
                  Zusätzlich zu unserer Mitgliedschaft bei Bioland (<a href="https://www.bioland.de/" target="_blank">www.bioland.de</a>) sind wir Mitglied im Ökoplant Verein für den ökologischen
                  Arznei- und Gewürzpflanzenanbau e.V. (<a
                    href="https://www.oekoplant-ev.de"
                    target="_blank"
                    >www.oekoplant-ev.de</a
                  >).<br />
                  Weitere Informationen finden Sie auf den Internetseiten.
                </p>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <viewer
      :images="images"
      :options="options"
      class="viewer"
      ref="viewer"
      @inited="inited"
    >
      <img
        v-for="image in images"
        :src="image.src"
        :key="image.index"
        class="image"
      />
    </viewer>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);

export default {
  data() {
    return {
      email: {
        addr: "mail@heberlein-kraeutertee.de",
        text: "mail@heberlein-kraeutertee.de"
      },
      images: [
        { index: 0, src: require("@/assets/betrieb/Orangenminze_Feld.jpg") },
        {
          index: 1,
          src: require("@/assets/betrieb/TürkischeMelisse_Feld2.jpg")
        },
        { index: 2, src: require("@/assets/betrieb/Anisysop.jpg") },
        //require("@/assets/betrieb/Sonnenblume_Feld2.jpg"),
        { index: 3, src: require("@/assets/betrieb/Traktor_Feld.jpg") },
        {
          index: 4,
          src: require("@/assets/betrieb/Spitzwegerich_Trocknungskiste.jpg")
        },
        { index: 5, src: require("@/assets/betrieb/Teetueten.jpg") }
      ],
      images2: [
        require("@/assets/betrieb/Orangenminze_Feld.jpg"),
        require("@/assets/betrieb/Sonnenblume_Feld2.jpg")
      ],
      options: {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: false,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: false,
        fullscreen: true,
        keyboard: true,
        loading: false
      }
    };
  },
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    showViewer(index) {
      this.$viewer.view(index);
      this.$viewer.show();
    }
  }
};
</script>

<style scoped>
.viewer {
  display: none;
}
.viewerImg {
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
</style>
